import api from 'data/client';
import { SalesData } from 'data/types/sales';
import { normalizeSales } from 'model/sales';

type Props = {
  brandId: string;
  dateStart: String;
  dateEnd: string;
};

const getSales = async ({ brandId, dateStart, dateEnd }: Props) => {
  const response = await api.get<SalesData>(
    `/reporting/sales?brandId=${brandId}&dateStart=${dateStart}&dateEnd=${dateEnd}`,
  );
  return normalizeSales(response.data);
};

export default getSales;
